import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AppInitService} from "./core/service/app-init.service";
import {SharedModule} from "./shared/shared.module";
import {REGION} from "@angular/fire/compat/functions";
import {DatePipe} from "@angular/common";
import {RouteReuseStrategy} from "@angular/router";
import {CustomRouteReuseStrategy} from "./core/routeReuseStrategy/custom-route-reuse-strategy";
import { MainWindowComponent } from './core/main-window/main-window.component';
import { HeaderComponent } from './core/header/header.component';
import { SideMenuComponent } from './core/side-menu/side-menu.component';
import { FooterComponent } from './core/footer/footer.component';

export function initializeApp(appInitService: AppInitService) {
  return (): Promise<any> => {
    return appInitService.Init();
  }
}

@NgModule({
  declarations: [
    AppComponent,
    MainWindowComponent,
    HeaderComponent,
    SideMenuComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  providers: [{provide: REGION, useValue: 'asia-northeast1'}, DatePipe,
    {provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true},
    {provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
